import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Landing Page</h1>
      <p>This is a public page.</p>
      <Link to="/login">Go to Login</Link>
    </div>
  );
};

export default LandingPage;
